import React from 'react';

export default function VistaInvitacion() {
  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: 1 }}>
        ACCESO NO AUTORIZADO
      </div>
    </div>
  );
}
